export default __webpack_public_path__ + "static/media/background.77303c72.jpg";